'use client';

import { useState } from 'react';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import AccountGeneralInformation from './AccountGeneralInformation';
import WalletBalancesTab from './WalletBalancesTab';
import SideDrawer from '../BaseDrawers/SideDrawer/SideDrawer';
import { AccountTabs, AccountTabsValue } from './AccountTabs';
import { Accounts } from './accounts/Accounts';
import { AccountsDrawerFooter } from './AccountsDrawerFooter';

export default function AccountsDrawer() {
	const handleCloseDrawer = useDrawersStore((s) => s.handleCloseDrawer);
	const [selectedTab, setSelectedTab] = useState<AccountTabsValue>('accounts');

	return (
		<SideDrawer.Container drawerName="accounts">
			<AccountGeneralInformation
				onClose={() => handleCloseDrawer('accounts')}
			/>
			<SideDrawer.Body className="thin-scroll">
				<AccountTabs
					selectedTab={selectedTab}
					setSelectedTab={setSelectedTab}
				/>
				{selectedTab === 'accounts' && <Accounts />}
				{selectedTab === 'wallet' && (
					<WalletBalancesTab onClose={() => handleCloseDrawer('accounts')} />
				)}
			</SideDrawer.Body>
			{selectedTab === 'accounts' && <AccountsDrawerFooter />}
		</SideDrawer.Container>
	);
}
